<template>
    <section v-if="hasPermissions(['Census-Log-Productivity Read', 'Census-Log-Productivity Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Productivity records will be automatically created if Associates are using a device to complete their work assignments. If you need to create a Productivity record, click "Log Productivity".  Select an Assignment and an Associate and adjust the Date if necessary. Once the record is created, click on the record and update any fields, then click "Save Changes".
            </p>
        </div>
        <div class="bar-container">
            <input class="date-input" type="date" v-model="search_date" @change="getApiRequest()" v-if="hasPermissions(['Census-Log-Productivity Read'])">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="log_productivity.length && hasPermissions(['Census-Log-Productivity Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options" style="grid-column-start: span 3;">
                <button class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Census-Log-Productivity Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>
        <div class="tab-content" v-show="log_productivity.length && hasPermissions(['Census-Log-Productivity Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                           <DinamicTable
                                :headers="table_headers"
                                :items="log_productivity"
                                :search="search"
                                :checkable="true"
                                :link="child_href"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

         <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'Log Productivity'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
            @saveView="saveView($event)"
        />

        <UpdateModal 
            :title="'Log Productivity Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
            @saveView="saveView($event)"
        />
        <HelperModal :helps="helps"/>
        <WaitingModal/>
    </section>
   <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                 from  'axios';
import moment                from 'moment'
import Breadcrumb            from  '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal          from  '@/components/WaitingModal'
import Resources             from  './resources'
import FormModal             from  './FormModal'
import UpdateModal           from  './UpdateModal'
import DeletionModal         from  '@/components/DeletionModal'
import DeletionMassiveModal  from  '@/components/DeletionMassiveModal'
import DinamicTable          from  '@/components/DinamicTable'
import HelperModal          from    '@/components/HelperModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'LogProductivity',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        DeletionMassiveModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        UnauthorizedComponent,
        HelperModal
        
    },

    data() {
        return {
            notyf,
            axios,
            child_href:         '/census-log-productivity/',
            title_page:         'Log Productivity',
            content_header:     this.$store.state.headers,
            rest_api:           `log_productivity`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Log Productivity',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       null,
            single_object:      {},
            log_productivity:   [],
            select_ids:         [],
            array_options:      {},
            search_date:        '',
            save_view:          false,
            moment,
            helps:              Resources.helps
        }
    },

    methods: {

        format_boolean(value){
            var boolean_string = ''
            value ? boolean_string = 'Yes' : boolean_string = 'No'
            return boolean_string
        },

         async unshift_object(new_object)
         {
            if(this.save_view)
            {
                window.location.href = `/census-log-productivity/${new_object.id}`
            }
            this.getApiRequest()
        },

        async splice_object(new_object)
        {
            if(this.save_view)
            {
                window.location.href = `/census-log-productivity/${new_object.single_object.id}`
            }
            this.getApiRequest()
        },

        async getApiRequest()
        {
            await this.api_request(`${this.rest_api}?date=${this.search_date}`)
        },

        form_modal(){
            window.$('#static').modal('show')
        },

        saveView(event)
        {
            this.save_view = event
        },

        massive_modal_delete()
        {
            this.select_ids = this.log_productivity.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive = await this.massive_delete({ ids: this.select_ids })

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.log_productivity.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.log_productivity.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        modal_deletion(index){
            this.global_index  = index
            this.single_object = this.log_productivity[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index){
            this.global_index  = index
            this.single_object = this.log_productivity[index]
            
            window.$('#static-update').modal('show')
        },

        fill_data(data) {
            this.log_productivity = data.logProductivity
            this.array_options = {
                daily_assignment_id: data.assignments,
                associate_id: data.associates  
            }
        },

        object_deletion(object_destroyed){
            axios.delete(`${this.rest_api}/${object_destroyed.id}`).then(()=>{
                this.global_index   =   ''
                this.single_object  =   {}
                this.log_productivity.splice(object_destroyed.index, 1)
                notyf.success('Log Productivity deleted successfully')
                window.$('#static-deletion').modal('hide')
            }).catch((error)=>{
                console.log(error)
            })
        }
    },

    async mounted() {
        if(this.hasPermissions(['Census-Log-Productivity Read', 'Census-Log-Productivity Write']))
        {
            this.search_date = moment().format("YYYY-MM-DD")
            await this.api_request(`${this.rest_api}?date=${this.search_date}`)
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.log_productivity.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>